export default "__VITE_ASSET__DQu$E7pq__"